import React from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
    component: React.ComponentType<any>;
    isAdminRoute?: boolean;
}

const isTokenValid = (token: string) => {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
    return payload.exp > currentTime;
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ component: Component, isAdminRoute = false, ...rest }) => {
    const token = localStorage.getItem('token');

    if (!token || !isTokenValid(token)) {
        localStorage.removeItem('token');
        return <Navigate to="/login" />;
    }

    if (isAdminRoute) {
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (!payload.admin) {
            return <Navigate to="/login" />;
        }
    }

    return <Component {...rest} />;
};

export default ProtectedRoute;